"use client";

import { useEffect, useState } from "react";

import useCiamSsoRedirect from "@/hooks/customer/useCiamSsoRedirect";
import LoadingComponent from "./ui/LoadingComponent";

interface AuthValidatorProps {
  containerClass?: string;
  children: React.ReactNode;
}

const AuthValidator: React.FC<AuthValidatorProps> = (props) => {
  const { children, containerClass } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [hasCiamSDK, setHasCiamSDK] = useState(false);
  const { ssoRedirect } = useCiamSsoRedirect();

  useEffect(() => {
    const fetchData = async () => {
      setHasCiamSDK(true);
      const isLoggedIn = await window.ciamSDK.getLoggedInState();

      if (!isLoggedIn) {
        ssoRedirect();
      } else {
        setIsLoading(false);
      }
    };

    const pollForCiamSDK = async () => {
      const maxRetries = 20;
      let attempt = 0;

      while (attempt !== maxRetries) {
        if (window.ciamSDK) {
          try {
            fetchData();
            return;
          } catch (error) {
            console.warn(
              `SDK loaded but not ready, attempt ${attempt + 1}:`,
              error,
            );
          }
        }

        await new Promise((resolve) => setTimeout(resolve, 800));
        attempt++;
      }
      setIsLoading(false);
    };

    pollForCiamSDK();
  }, [ssoRedirect]);

  if (isLoading) {
    return (
      <>
        <div className={containerClass}>
          <LoadingComponent />
        </div>
      </>
    );
  }

  if (!isLoading && !hasCiamSDK) {
    return (
      <div role="status" className="flex justify-center w-full py-12">
        <div className="flex flex-col w-[400px]">
          <h1>Something went wrong please refresh the page</h1>
        </div>
      </div>
    );
  }

  return !isLoading && children;
};
export default AuthValidator;
